import React from 'react';
import PropTypes from 'prop-types';

const filterDelay = 100;

class FilterListItemComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: false,
    };
  }

  render() {
    const { item, setSelected, children } = this.props;
    const { selected } = this.state;
    const className = selected ? 'item-selected' : null;
    return (
      <button
        className={className}
        type="button"
        onClick={() => {
          this.setState({
            selected: true,
          }, () => {
            setTimeout(() => {
              setSelected(item);
            }, filterDelay);
          });
        }}
      >
        {children}
      </button>
    );
  }
}

FilterListItemComponent.propTypes = {
  setSelected: PropTypes.func.isRequired,
  children: PropTypes.arrayOf(PropTypes.element).isRequired,
  item: PropTypes.shape({}).isRequired,
};

FilterListItemComponent.displayName = 'FilterListItemComponent';
export default FilterListItemComponent;
